/**
 * Utilitaires de tracking événementiel envoyés à dataLayer (Google Tag Manager).
 * La personne SEA configure les déclencheurs dans GTM sur ces noms d'événements.
 *
 * Événements exposés :
 *  - call_click   { location: 'floating_button' | 'header' | 'header_mobile' | 'hero' | 'cta' | 'footer' | 'disclaimer' }
 *  - email_click  { email: string, location: string }
 *  - login_attempt (sur soumission du formulaire login)
 */

const push = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    // Silencieux : ne casse jamais l'UX si GTM absent
  }
};

export const trackCallClick = (location) => push("call_click", { location });
export const trackEmailClick = (email, location) => push("email_click", { email, location });
export const trackLoginAttempt = () => push("login_attempt");
